import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NativeApp, Style } from '@local/client-contracts';
import { EventInfo, EventsService } from '@shared/services';
import { HubService } from 'src/app/bar/services/hub.service';
import { Constants } from '@local/common';

interface EmptyState {
  subtitle: string;
  buttonText: string;
  actionClick: Function;
}

@Component({
  selector: 'connect-pc',
  templateUrl: './connect-pc.component.html',
  styleUrls: ['./connect-pc.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConnectPcComponent {
  icon: Style.Icon;
  options: { [key: string]: EmptyState };
  currOption: EmptyState;

  @Input() set nativeAppStatus(value: NativeApp.Status) {
    this.currOption = this.options[value];
    this.sendEventHub('status_view');
  }
  @Input() isLauncher: boolean = false;

  constructor(private eventsService: EventsService, public hubService: HubService) {
    this.icon = {
      lightUrl: './assets/empty-state/no-connected-pc/empty-state-light.svg',
      darkUrl: './assets/empty-state/no-connected-pc/empty-state-dark.svg',
    };

    this.options = {
      'not-installed': {
        subtitle: 'Download the desktop App and get access to all the files and applications on your computer.',
        buttonText: 'Download Desktop App',
        actionClick: () => this.goToDownloadPage(),
      },
      installed: {
        subtitle: 'You need to open the Desktop App to get access to all the files and applications on your computer.',
        buttonText: 'Open Desktop App',
        actionClick: () => this.openDesktopApp(),
      },
    };
  }

  sendEventHub(eventType: string, target: string = undefined) {
    const location: string = this.hubService.currentLocation;
    const eventData: Partial<EventInfo> = {
      label: 'unsupported_on_web',
      location: { title: location },
    };
    if (target) {
      eventData.target = target;
    }
    this.eventsService.event(eventType, eventData);
  }

  goToDownloadPage() {
    window.open(Constants.DOWNLOAD_DEKSTOP_APP, '_blank');
    this.sendEventHub('interaction_click', 'download');
  }

  openDesktopApp() {
    window.open(`unleash://${window.location.host}?ref=browser`, '_blank');
    this.sendEventHub('interaction_click', 'open');
  }
}
